import * as React from "react";

import ReploBuilder from "@svg/billing/ReploBuilder";

import PlanSummaryBlock from "./PlanSummaryBlock";

const SimpleChatMessagesUsage = ({
  className,
  currentChatMessages,
  maximumChatMessages,
}: {
  className?: string;
  currentChatMessages: number;
  maximumChatMessages: number | null;
}) => {
  return (
    <PlanSummaryBlock className={className}>
      <div className="flex items-center gap-3">
        <ReploBuilder />
        <span className="text-sm font-medium text-muted">Chat Messages</span>
      </div>
      <div>
        <span className="header-h3"> {currentChatMessages}</span>
        <span className="text-xs"> / {maximumChatMessages ?? "unlimited"}</span>
      </div>
    </PlanSummaryBlock>
  );
};

export default SimpleChatMessagesUsage;
